import { Component, OnDestroy, OnInit } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';
import { Subscription } from 'rxjs/Rx';
import { environment } from '../../../environments/environment';
import { SceneService } from '../../services/scene.service';
import { Hotspot } from '../../models/hotspot';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Header Component.
 */
export class HeaderComponent implements OnDestroy, OnInit
{
	/**
	 * Environment.
	 */
	public environment = environment;

	/**
	 * Navigation.
	 */
	public navigation: Hotspot[];

	/**
	 * Language.
	 */
	public language: string;

	/**
	 * Subscripton for the language.
	 */
	private languageSubscription: Subscription;

	/**
	 * Subscripton for the sidebar service.
	 */
	private sidebarSubscription: Subscription;

	/**
	 * State: Is the sidebar open?.
	 */
	public sidebarIsOpened = false;

	/**
	 * Constructor.
	 */
	public constructor(
		private sceneService: SceneService,
		private sidebarService: SidebarService,
		private translateService: TranslateService
	)
	{}

	/**
	 * Lifecycle-Hook: OnInit.
	 */
	public ngOnInit()
	{
		this.sidebarSubscription = this.sidebarService.sidebarIsOpened.subscribe(
			(status) => this.sidebarIsOpened = status
		);

		// Language.
		this.language = this.translateService.currentLang;
		this.languageSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
			this.language = event.lang;
		});

		// Navigation.
		this.navigation = this.sceneService.getNavigation();
	}

	/**
	 * Toggle the sidebar.
	 */
	public toggleSidebar()
	{
		this.sidebarService.toggle();
	}

	/**
	 * Lifecycle-Hook: OnDestroy.
	 */
	public ngOnDestroy()
	{
		this.languageSubscription.unsubscribe();
		this.sidebarSubscription.unsubscribe();
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/header/header.component.ts